module.exports = __webpack_public_path__ + "img/Superb_sword_06.266421f8.png";